import React from 'react';
import styles from 'components/questions/questions.module.css';
import i18next from 'i18next';

import { convertToStringOrNull } from 'utils/dataTypes.utils';
import { UA_LANG } from 'components/langSwitcher/constants';

interface IQuestionItemProps {
    id: number;
    text: string;
    emoji?: JSX.Element;
    iconBefore?: JSX.Element;
    iconAfter?: JSX.Element;
    animatedClassName: string | null;
}

export const QuestionItem = ({
    id,
    text,
    emoji,
    iconBefore,
    iconAfter,
    animatedClassName,
}: IQuestionItemProps) => {
    const itemsWithMarginLeft = new Set([3, 4, 6, 7]);
    const itemsWithSmallMB = new Set([1, 3, 6]);
    const itemsWithBigMB = new Set([2, 4, 5]);
    const gradientItems = new Set([1, 2, 5]);

    const isSetLangUA = i18next.resolvedLanguage?.includes(UA_LANG);
    const getQuestionItemFontSize = isSetLangUA
        ? `${styles.questions__itemUa}`
        : '';

    const getMarginLeft = (id: number): string | null =>
        convertToStringOrNull(
            itemsWithMarginLeft.has(id),
            `${styles.questions__itemBox_marginLeft}`
        );

    const getSmallMB = (id: number): string | null =>
        convertToStringOrNull(
            itemsWithSmallMB.has(id),
            `${styles.questions__itemBox_marginBottomSmall}`
        );

    const getBigMB = (id: number): string | null =>
        convertToStringOrNull(
            itemsWithBigMB.has(id),
            `${styles.questions__itemBox_marginBottomBig}`
        );

    const getGradientColor = (id: number): string | null =>
        convertToStringOrNull(
            gradientItems.has(id),
            `${styles.questions__item_gradient}`
        );

    return (
        <li
            id={id.toString()}
            className={`${styles.questions__itemBox} ${animatedClassName} ${getMarginLeft(id)} ${getSmallMB(id)} ${getBigMB(id)}`}
        >
            {iconBefore && (
                <div
                    className={`${styles.questions__item} ${styles.questions__item_icon} ${styles.questions__item_marginRight} ${styles.questions__item_gradient}`}
                >
                    <div className={styles.question__icon}>{iconBefore}</div>
                </div>
            )}
            <div
                className={`${styles.questions__item} ${getQuestionItemFontSize} ${getGradientColor(id)}`}
            >
                <span>{text}</span>
                {emoji && <div className={styles.question__emoji}>{emoji}</div>}
            </div>
            {iconAfter && (
                <div
                    className={`${styles.questions__item} ${styles.questions__item_icon} ${styles.questions__item_marginLeft}`}
                >
                    <div className={styles.question__icon}>{iconAfter}</div>
                </div>
            )}
        </li>
    );
};
